<template>
  <div>
    <el-input placeholder="" readonly :value="displayValue" :clearable="true" @change="handleChange">
      <template slot="append"><el-button  @click="open" :class="selIconCls||''">{{!selIconCls ? '选择' : ' '}}</el-button></template>
    </el-input>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: {}
    }
  },

  data() {
    return {
      selIconCls:(window.$Env && $Env.selIconCls),
    };
  },

  computed: {
    displayValue() {
      if (this.value) {
        if (this.value.name !== undefined) {
          return this.value.name;
        }
      }
      return "";
    }
  },

  methods: {
    open() {
      // PF.show(
      //   "tree",
      //   {
      //     url: this.mwUrl("/api/process/getLatestProcessDefinitionTree"),
      //     checkNodes: [],
      //     multiple: false,
      //     singleLeaf: true,
      //     multipleLeaf: true,
      //     clearBtn: false,
      //     search: true
      //   },
      //   res => {
      //     if (res) {debugger
      //       this.$emit('input', res)
      //     }
      //   }
      // );
       let me=this;
       PF.show('treeTable', {
          url: me.mwUrl("/api/app/listSystemApplicationTree"),treeDefaultParams: {}
          ,size:'small_large',showTreeToolbar:false,defaultPercent:50,
          selectFirst: true,asyncLoadOnce:true, clearBtn: false, title: '选择流程', changed: function (data) {
            this.defaultParams = {applicationId:data.id};
          }, api: 'process.listLatestDefinition', singleSelect: true,columns: [{type: 'selection'},
            {prop: 'name', label: '名称', tooltip: true}],
        }, function (res) {
          if (res && res.length > 0) {
             me.$emit('input', res[0])
          }
        });
    },

    handleChange(val) {
      if (!val) {
        this.$emit('input', {})
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/flowInterfering/common/flowSelect.vue